import React, { RefObject } from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import 'twin.macro';
import { useTranslation } from 'react-i18next';
import { CustomFieldDefinition, CustomFieldValue } from 'types/customField';
import { CustomFieldDefinitionDefaults } from 'types/customField';
import { EditCustomFieldDefinition } from '../EditCustomFieldDefinition';
import { orderByCustomFieldDefinitionsOrder } from '@teetsh/app/src/utils/customFields/orderByCustomFieldDefinitionsOrder';

export interface CustomFieldButtonsProps {
  definitions: CustomFieldDefinition[];
  values: CustomFieldValue[];
  onChange: (values: CustomFieldValue[]) => void;
  onUpdateDefinition: (def: CustomFieldDefinition) => Promise<void>;
  onDeleteDefinition: (defId: string) => Promise<void>;
  enableEdit: boolean;
  inputRefs?: RefObject<HTMLInputElement[]>;
  onAddCallback?: () => void;
  translations?: {
    noName: string;
  };
}

export function CustomFieldButtons({
  definitions,
  values,
  onChange,
  onUpdateDefinition,
  onDeleteDefinition,
  enableEdit,
  inputRefs,
  onAddCallback,
  translations,
}: CustomFieldButtonsProps) {
  const { t } = useTranslation(['common']);

  const defaultTranslations = {
    noName: t('customFields.noName'),
  };

  const finalTranslations = { ...defaultTranslations, ...translations };

  return (
    <>
      {definitions.map((def, index) => (
        <div
          tw="flex items-center gap-2 flex-nowrap"
          className="group"
          key={def.id}
        >
          <div tw="flex items-center gap-x-1">
            <Button
              tw="flex-grow relative"
              small
              icon={CustomFieldDefinitionDefaults[def.type].icon}
              onClick={() => {
                const matchingCustomField = (values || []).find(
                  i => i.id === def.id,
                );
                if (matchingCustomField) {
                  return setTimeout(() => {
                    // froala case 😱
                    if (
                      (inputRefs as any)?.current[index]?.current?.editor?.el
                    ) {
                      (inputRefs as any)?.current[
                        index
                      ]?.current?.editor?.el?.focus();
                      return;
                    }
                    if ((inputRefs as any)?.current[index]?.current?.click) {
                      (inputRefs as any)?.current[index]?.current?.click();
                    }
                  }, 1);
                }

                const newFieldWithType =
                  CustomFieldDefinitionDefaults[def.type].genNewItem(def);
                const newField: CustomFieldValue = {
                  id: newFieldWithType.id,
                  value: newFieldWithType.value,
                  items: newFieldWithType.items,
                };
                onChange(
                  orderByCustomFieldDefinitionsOrder(definitions, [
                    ...(values || []),
                    newField,
                  ]),
                );
                onAddCallback?.();
                return setTimeout(() => {
                  // froala case 😱
                  if ((inputRefs as any)?.current[index]?.current?.editor?.el) {
                    const inputToFocus = (inputRefs as any)?.current[index]
                      ?.current?.editor?.el;
                    // Un peu degeu mais bon... sinon le focus n'est pas pris en compte...
                    setTimeout(() => {
                      inputToFocus.focus();
                    }, 10);
                    return;
                  }
                  if ((inputRefs as any)?.current[index]?.current?.click) {
                    (inputRefs as any)?.current[index]?.current.click();
                  }
                }, 1);
              }}
              alignText="left"
            >
              {def.name ? def.name : finalTranslations.noName}
            </Button>

            {enableEdit && (
              <EditCustomFieldDefinition
                customFieldDefinition={def}
                onUpdateDefinition={onUpdateDefinition}
                onDeleteDefinition={() => onDeleteDefinition(def.id)}
                showEditButtonAlways
              />
            )}
          </div>
        </div>
      ))}
    </>
  );
}
